import { createSlice } from '@reduxjs/toolkit';

export const onlineQuoteFormSlice = createSlice({
    name: 'onlineQuoteForm',
    initialState: {
        value: {
            package: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            age: null,
            gender: '',
            state: '',
            zipCode: '',
            tobaccoUser: '',
            medications: '',
            spouseAge: null,
            numberOfDependents: null,
            dependent1Age: null,
            dependent2Age: null,
            dependent3Age: null,
            dependent4Age: null,
            dependent5Age: null,
            dependent6Age: null,
            dependent7Age: null,
        },
    },
    reducers: {
        setOnlineQuoteForm: (state, action) => {
            const newValue = action.payload;
            state.value = { ...state.value, ...newValue };
        },
    },
});

// Action creators are generated for each case reducer function
export const { setOnlineQuoteForm } = onlineQuoteFormSlice.actions;

export default onlineQuoteFormSlice.reducer;
